import { render, staticRenderFns } from "./FhMenuAgricultor.vue?vue&type=template&id=6d240228&scoped=true&"
import script from "./FhMenuAgricultor.vue?vue&type=script&lang=js&"
export * from "./FhMenuAgricultor.vue?vue&type=script&lang=js&"
import style0 from "./FhMenuAgricultor.vue?vue&type=style&index=0&id=6d240228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d240228",
  null
  
)

export default component.exports